module.exports = __webpack_public_path__ + "img/g5.92a832f4.jpg";